import { createFileRoute } from '@tanstack/react-router';
import { BookingRulePage } from '@/features/rules/pages/rules-pages';

export const Route = createFileRoute('/_app/rules/booking')({ component: BookingRulePage });
